import { MenuItem, styled, TextField, Tooltip } from "@mui/material";
import * as React from "react";
import HelpIcon from "@mui/icons-material/Help";

function InfoLabel() {
  return (
    <>
      Metering direction
      <Tooltip
        placement="top"
        title={"In normal mode, positive values equal consumption and negative values production."}
      >
        <HelpIcon className="myIcon" fontSize="medium" />
      </Tooltip>
    </>
  );
}

const StyledTextField = styled(TextField)({
  "& .MuiFormLabel-root": {
    display: "flex",
    alignItems: "center",
    "& .myIcon": {
      paddingLeft: "8px",
      order: 999,
    },
  },
  paddingTop: 0,
});

export default function MeteringDirectionSelect({ value, onChange, disabled = false }) {
  return (
    <StyledTextField select label={<InfoLabel />} disabled={disabled} fullWidth value={value} onChange={onChange}>
      <MenuItem value={1}>Normal</MenuItem>
      <MenuItem value={-1}>Inverted</MenuItem>
    </StyledTextField>
  );
}
